import { atom, selector } from 'recoil';

const TARGET_NUM_TOYS = 3;

// states: home -> intro -> main -> result
const gameProgressState = atom({
  key: 'gameProgress',
  default: 'home'
});

const toysState = atom({
  key: 'toys',
  default: [
    {
      id: '01',
      name: '二手衣',
      img:'/img/toys/01Second-hand-clothes.png',
      selected: false,
    },
    {
      id: '02',
      name: '淨灘',
      img:'/img/toys/02Clean-beach.png',
      selected: false,
    },
    {
      id: '03',
      name: '手譯',
      img:'/img/toys/03Hand-translation.png',
      selected: false,
    },
    {
      id: '04',
      name: '田董米',
      img:'/img/toys/04TianDongmi.png',
      selected: false,
    },
    {
      id: '05',
      name: '海龜',
      img:'/img/toys/05Sea-turtle.png',
      selected: false,
    },
    {
      id: '06',
      name: '揹水',
      img:'/img/toys/06Backwater.png',
      selected: false,
    },
    {
      id: '07',
      name: '創作環島',
      img:'/img/toys/07Create-roundabout.png',
      selected: false,
    },
    {
      id: '08',
      name: '海牛',
      img:'/img/toys/08manatee.png',
      selected: false,
    },
    {
      id: '09',
      name: '浪犬',
      img:'/img/toys/09Langdog.png',
      selected: false,
    },
    {
      id: '10',
      name: '書屋',
      img:'/img/toys/10Bookstore.png',
      selected: false,
    },
  ]
})

const selectedToysCountState = selector({
  key: 'selectedToysCount',
  get: ({ get }) => {
    const toys = get(toysState);
    return toys.filter(({ selected }) => selected).length;
  }
});

const remainingToysCountState = selector({
  key: 'remainingToysCount',
  get: ({ get }) => {
    const selectedToysCount = get(selectedToysCountState);
    return TARGET_NUM_TOYS - selectedToysCount;
  }
});

const replayState = selector({
  key: 'replay',
  set: ({ get, set }) => {
    const progress = get(gameProgressState)
    const toys = get(toysState)
    if (progress === 'result') {
      set(gameProgressState, 'intro')
      set(toysState, toys.map((toy) => ({
        ...toy,
        selected: false
      })))
    } else {
      console.warn('incorrect state transition')
    }
  }
})

export {
  gameProgressState,
  toysState,
  selectedToysCountState,
  remainingToysCountState,
  replayState
}
